"use client";

import { SignedIn, SignedOut } from "@clerk/nextjs";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { MID_PAGE_CTA_COPY } from "./pricingPageCopy";

export function PricingMidPageCta() {
  return (
    <section className="bg-white px-4 py-14 text-slate-950 sm:px-6 sm:py-16 lg:px-8">
      <div className="mx-auto max-w-[1120px]">
        <div className="relative isolate overflow-hidden rounded-[30px] bg-[#06291C] px-5 py-12 text-center shadow-[0_30px_90px_-48px_rgba(6,41,28,0.75)] ring-1 ring-emerald-200/15 sm:px-10 sm:py-16">
          <div
            className="pointer-events-none absolute -left-16 -top-12 h-[220px] w-[220px] opacity-30"
            style={{
              backgroundImage:
                "radial-gradient(circle, rgba(134,239,172,0.72) 1px, transparent 1px)",
              backgroundSize: "14px 14px",
            }}
            aria-hidden
          />
          <div
            className="pointer-events-none absolute -bottom-16 right-0 h-[240px] w-[240px] opacity-25"
            style={{
              backgroundImage:
                "radial-gradient(circle, rgba(253,224,71,0.58) 1px, transparent 1px)",
              backgroundSize: "16px 16px",
            }}
            aria-hidden
          />

          <div className="relative z-10 mx-auto max-w-3xl">
            <h2 className="text-balance text-3xl font-black leading-tight tracking-tight text-white sm:text-5xl">
              {MID_PAGE_CTA_COPY.heading}
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-pretty text-base font-medium leading-7 text-emerald-50/85 sm:text-lg">
              {MID_PAGE_CTA_COPY.subtext}
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                href={MID_PAGE_CTA_COPY.primary.href}
                className="inline-flex h-14 w-full items-center justify-center gap-3 rounded-full bg-[#08A62F] px-7 text-base font-black text-white shadow-[0_18px_34px_-22px_rgba(134,239,172,0.95)] transition-colors duration-150 hover:bg-[#0BB63B] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-emerald-200 sm:w-auto"
              >
                {MID_PAGE_CTA_COPY.primary.label}
                <ArrowRight className="h-5 w-5" strokeWidth={2.6} aria-hidden />
              </Link>

              <SignedIn>
                <Link
                  href={MID_PAGE_CTA_COPY.signedInSecondary.href}
                  className="inline-flex h-14 w-full items-center justify-center rounded-full border border-white/25 bg-white/10 px-7 text-base font-black text-white transition-colors duration-150 hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-emerald-200 sm:w-auto"
                >
                  {MID_PAGE_CTA_COPY.signedInSecondary.label}
                </Link>
              </SignedIn>
              <SignedOut>
                <Link
                  href={MID_PAGE_CTA_COPY.signedOutSecondary.href}
                  className="inline-flex h-14 w-full items-center justify-center rounded-full border border-white/25 bg-white/10 px-7 text-base font-black text-white transition-colors duration-150 hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-emerald-200 sm:w-auto"
                >
                  {MID_PAGE_CTA_COPY.signedOutSecondary.label}
                </Link>
              </SignedOut>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
